// extracted by mini-css-extract-plugin
module.exports = {"hideMenu":"LandingSidemenu_hideMenu__2EHEr","wavesDark":"LandingSidemenu_wavesDark__586jl"};